(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Carousel from 'react-bootstrap/Carousel';
import { Link } from 'react-router-dom';
import ScrollToTop from '../components/scroll-to-top';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet';
import ImageWebp from '../components/custom/ImageWebp';
import '../assets/styles/components/Home.scss';
import previewvideo from '../assets/static/home/preview.jpg';
import previewvideomobile from '../assets/static/home/preview-mobile.jpg';
import amenity1 from '../assets/static/home/amenities-01.jpg';
import amenity2 from '../assets/static/home/amenities-02.jpg';
import amenity3 from '../assets/static/home/amenities-03.jpg';
import amenity4 from '../assets/static/home/amenities-04.jpg';
import { NEXT_PUBLIC_ADDRESS_COMPANY, NEXT_PUBLIC_CITY_COMPANY, NEXT_PUBLIC_ZIPCODE_COMPANY } from '../utils/utilities';
import Modal from 'react-bootstrap/Modal';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibletranscript: false,
      showModal: true
    };
    this.clickVideo = this.clickVideo.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  clickVideo() {
    this.setState({
      visibletranscript: true
    });
  }

  closeModal() {
    this.setState({
      showModal: false
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "The District"), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: "Introducing Mosaic's new addition! This is a Spanish-style multi-unit property located just across from USC Village on Hoover & 28th St."
    })), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement("div", {
      id: "content",
      className: "bypass-block-target",
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement(Carousel, {
      fade: true,
      className: "max-width-tops"
    }, /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "tophome home1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionhome"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/contact"
    }, /*#__PURE__*/React.createElement("h2", null, "Preleasing "), /*#__PURE__*/React.createElement("p", null, "for Fall 2025"))))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "tophome home2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionhome"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/contact"
    }, /*#__PURE__*/React.createElement("h2", null, "Preleasing "), /*#__PURE__*/React.createElement("p", null, "for Fall 2025"))))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "tophome home3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionhome"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/contact"
    }, /*#__PURE__*/React.createElement("h2", null, "Preleasing "), /*#__PURE__*/React.createElement("p", null, "for Fall 2025"))))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "tophome home4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionhome"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/contact"
    }, /*#__PURE__*/React.createElement("h2", null, "Preleasing "), /*#__PURE__*/React.createElement("p", null, "for Fall 2025")))))), /*#__PURE__*/React.createElement(Container, {
      as: "article",
      className: "content"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "h1 sr-only"
    }, NEXT_PUBLIC_ADDRESS_COMPANY, ", ", /*#__PURE__*/React.createElement("br", null), NEXT_PUBLIC_CITY_COMPANY, ", ", NEXT_PUBLIC_ZIPCODE_COMPANY), /*#__PURE__*/React.createElement("img", {
      src: "/images/logo.png",
      alt: "The District",
      className: "d-block mx-auto mb-5",
      width: "270",
      height: "65"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-center"
    }, "Located right off The Row on 28th Street, these luxury studios and 2 bedroom apartments come fully furnished and equipped with stainless steel appliances, a Sonos sound system, and in-unit laundry. Most units feature space-saving, transformable furniture by Ori Living. All it takes is the touch of a button, a tap on your phone, or a voice command to see walls move and rooms slide in and out of the scene, effortlessly responding to the rhythm and flow of modern life. This modern property offers exterior amenities such as outdoor seating, bonfire pits, grilling stations, and many more! Schedule your property showing today to see it for yourself!")), /*#__PURE__*/React.createElement("div", {
      className: "bgfixed bg1",
      role: "img",
      "aria-label": "fixed image before amenities section"
    }, /*#__PURE__*/React.createElement("p", {
      className: "sr-only"
    }, "Community area, residents are enjoying together")), /*#__PURE__*/React.createElement(Container, {
      as: "section",
      className: "content"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/logo.png",
      alt: "The District",
      className: "d-block mx-auto mb-4",
      width: "194",
      height: "47"
    }), /*#__PURE__*/React.createElement("h2", {
      className: "h1"
    }, "Amenities Catered to You"), /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between mb-5 dflexamenities"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/amenities"
    }, /*#__PURE__*/React.createElement(ImageWebp, {
      src: amenity1,
      alt: "amenities 1",
      className: "img-fluid",
      width: "275",
      height: "275"
    })), /*#__PURE__*/React.createElement("a", {
      href: "/amenities"
    }, /*#__PURE__*/React.createElement(ImageWebp, {
      src: amenity3,
      alt: "amenities 3",
      className: "img-fluid",
      width: "275",
      height: "275"
    })), /*#__PURE__*/React.createElement("a", {
      href: "/amenities"
    }, /*#__PURE__*/React.createElement(ImageWebp, {
      src: amenity2,
      alt: "amenities 2",
      className: "img-fluid",
      width: "275",
      height: "275"
    })), /*#__PURE__*/React.createElement("a", {
      href: "/amenities"
    }, /*#__PURE__*/React.createElement(ImageWebp, {
      src: amenity4,
      alt: "amenities 4",
      className: "img-fluid",
      width: "275",
      height: "275"
    }))), /*#__PURE__*/React.createElement("p", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/amenities",
      className: "btn btn-secondary"
    }, "View Amenities"))), /*#__PURE__*/React.createElement("div", {
      className: "bgfixed bg2",
      role: "img",
      "aria-label": "fixed image before floor plan section"
    }, /*#__PURE__*/React.createElement("p", {
      className: "sr-only"
    }, "swimming pool")), /*#__PURE__*/React.createElement(Container, {
      as: "section",
      className: "content contentflooplanshome"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "h1"
    }, "Fully Renovated Studios to 2 Bedroom ", /*#__PURE__*/React.createElement("br", null), " Apartments Available"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      className: "mb-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cardamenity"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/floorplans/studio/studio.jpg",
      alt: "Floorplan studio",
      className: "img-fluid",
      width: "246",
      height: "285"
    }), /*#__PURE__*/React.createElement("div", {
      className: "detailfloor"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "h2"
    }, "studio"), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("caption", {
      className: "sr-only"
    }, "studio - Details"), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Beds"), /*#__PURE__*/React.createElement("td", null, "Studio")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Baths"), /*#__PURE__*/React.createElement("td", null, "1")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Price"), /*#__PURE__*/React.createElement("td", null, "Call for details"))))))), /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      className: "mb-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cardamenity"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/floorplans/2/jr.jpg",
      alt: "Floorplan Jr",
      className: "img-fluid",
      width: "246",
      height: "285"
    }), /*#__PURE__*/React.createElement("div", {
      className: "detailfloor"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "h2"
    }, "JUNIOR"), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("caption", {
      className: "sr-only"
    }, "2x2 Junior - Details"), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Beds"), /*#__PURE__*/React.createElement("td", null, "2")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Baths"), /*#__PURE__*/React.createElement("td", null, "1")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Price"), /*#__PURE__*/React.createElement("td", null, "Call for details"))))))), /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      className: "mb-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cardamenity"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/floorplans/2/standard.jpg",
      alt: "Floorplan 2x2_standard",
      className: "img-fluid",
      width: "246",
      height: "285"
    }), /*#__PURE__*/React.createElement("div", {
      className: "detailfloor"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "h2"
    }, "Standard"), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("caption", {
      className: "sr-only"
    }, "Standard - Details"), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Beds"), /*#__PURE__*/React.createElement("td", null, "2")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Baths"), /*#__PURE__*/React.createElement("td", null, "2")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Price"), /*#__PURE__*/React.createElement("td", null, "Call for details"))))))), /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      className: "mb-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cardamenity"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/floorplans/2/luxe.jpg",
      alt: "Floorplan 2x2_luxe",
      className: "img-fluid",
      width: "246",
      height: "285"
    }), /*#__PURE__*/React.createElement("div", {
      className: "detailfloor"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "h2"
    }, "Luxe"), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("caption", {
      className: "sr-only"
    }, "Luxe - Details"), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Beds"), /*#__PURE__*/React.createElement("td", null, "2")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Baths"), /*#__PURE__*/React.createElement("td", null, "2")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Price"), /*#__PURE__*/React.createElement("td", null, "Call for details"))))))))), /*#__PURE__*/React.createElement("div", {
      className: "bgfixed bg3",
      role: "img",
      "aria-label": "fixed image before footer"
    }, /*#__PURE__*/React.createElement("p", {
      className: "sr-only"
    }, "example of apartment, living room"))), /*#__PURE__*/React.createElement(Footer, null), /*#__PURE__*/React.createElement(Modal, {
      id: "virtualModal",
      size: "lg",
      centered: true,
      show: this.state.showModal,
      onHide: this.closeModal
    }, /*#__PURE__*/React.createElement(Modal.Header, {
      closeButton: true
    }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("h3", {
      className: "modalH1"
    }, "JOIN VIP CONTACT LIST TO BE THE FIRST TO GET HOUSING INFO FOR FALL", ' ', /*#__PURE__*/React.createElement("strong", {
      className: "strongModal"
    }, "2025")), /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/contact",
      className: "btn btn-secondary"
    }, "Contact US")))));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = Home;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Home, "Home", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/Home.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/Home.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();